import {Pipe, PipeTransform} from '@angular/core';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import {filter, map, Observable, take} from 'rxjs';
import {UserTimezone} from '../main/signing-pages/signing-page/signing-page.dto';

@Pipe({ 
    name: 'userTimeZoneFormat',
    standalone: true
 })

/*
 * returns the date formate using moment.js
 */
export class UserTimeZoneFormatPipe implements PipeTransform {

    private _userTimezone$ = this._sharedStoreFacade$.userTimezone$;
    constructor (private _sharedStoreFacade$: SharedStoreFacade) {}


    transform(hasTime: boolean = false): Observable<string> {
        return this._userTimezone$.pipe(
            filter(timeZone => Object.keys(timeZone)?.length > 0),
            take(1),
            map(userTimeZone => this.getUserTimeZoneFormat(userTimeZone, hasTime))
          );
    }


    private getUserTimeZoneFormat(config: UserTimezone, hasTime: boolean = false): string {
        let { date_format } = config;
        const { month_format, hours_format} = config;

        //@if month_format is 1 then date will be like this (2024 09 18) 
        //@if month_format is 0 then date will be like this (2024 Sep 18) 

        // Define month format based on the `month_format` setting
        const monthFormat = month_format === 1 ? 'm' : 'M';
        
        // Replace format for flatpickr
        date_format = date_format.replace('DD', 'd').replace('YYYY', 'Y')
        
        // Construct the base date format string
        let finalFormat = `${date_format.replace('MM', monthFormat)}`;

    
        // Append time format if the date includes a time component
        if (hasTime) {
            finalFormat += ` ${hours_format === '24 hours' ? 'HH:mm' : 'hh:mm A'}`;
        }
        

        // Use replace with a regular expression to replace all '-' with a space if month_format is 1
        if (month_format === 0) {
            finalFormat = finalFormat.replace(/-/g, ' ');
        }
        return finalFormat;
    }
}
